export const state = () => ({
  meta: null,
  stage: null,
  services_items: null,
  badges: null,
  gmp: null,
  ads: null,
  tools: null,
  marketingIntelligence: null,
  about: null,
  contact: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  services_items(state) {
    return state.services_items
  },
  badges(state) {
    return state.badges
  },
  gmp(state) {
    return state.gmp
  },
  ads(state) {
    return state.ads
  },
  tools(state) {
    return state.tools
  },
  marketingIntelligence(state) {
    return state.marketingIntelligence
  },
  about(state) {
    return state.about
  },
  contact(state) {
    return state.contact
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setServices(state, { data }) {
    state.services_items = data
  },
  setBadges(state, { data }) {
    state.badges = data
  },
  setGMP(state, { data }) {
    state.gmp = data
  },
  setAds(state, { data }) {
    state.ads = data
  },
  setTools(state, { data }) {
    state.tools = data
  },
  setMarketingIntelligence(state, { data }) {
    state.marketingIntelligence = data
  },
  setAbout(state, { data }) {
    state.about = data
  },
  setContact(state, { data }) {
    state.contact = data
  }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/stage.json`)
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getServices({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/services.json`)
      .then((res) => {
        commit('setServices', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getBadges({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/badges.json`)
      .then((res) => {
        commit('setBadges', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getGMP({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/gmp.json`)
      .then((res) => {
        commit('setGMP', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getAds({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/ads.json`)
      .then((res) => {
        commit('setAds', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getTools({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/tools.json`)
      .then((res) => {
        commit('setTools', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getMarketingIntelligence({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/marketing_intelligence.json`)
      .then((res) => {
        commit('setMarketingIntelligence', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getAbout({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/about.json`)
      .then((res) => {
        commit('setAbout', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/contact.json`)
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
